import { axiosGet } from 'shared/api/axios'

interface getRowsProps {
  url: string
}

const getRows = async (props: getRowsProps) => {
  const response = await axiosGet(props.url)

  return response.data
}

export default getRows
